import getCookie from './lib/GetCookie';

const textSize = (adjustor: HTMLElement) => {
  let fontSize = 16;

  const root = document.querySelector(':root') as HTMLElement;

  const plus = adjustor.querySelector('.plus');
  const minus = adjustor.querySelector('.minus');

  if (getCookie('fontSize') !== '') {
    fontSize = parseInt(getCookie('fontSize'), 10);
    root.style.fontSize = `${fontSize}px`;
  }
  plus.addEventListener('click', () => {
    if (fontSize < 26) {
      fontSize += 2;
      document.cookie = `fontSize=${fontSize}`;
      root.style.fontSize = `${fontSize}px`;
    }
  });

  minus.addEventListener('click', () => {
    if (fontSize > 6) {
      fontSize -= 2;
      document.cookie = `fontSize=${fontSize}`;

      root.style.fontSize = `${fontSize}px`;
    }
  });
};

export default textSize;
